import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import {
    withStyles, Button, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody
} from "@material-ui/core";
import moment from "moment-timezone";
import CancelAcceptForm from "../../../../Common/CancelAcceptForm";
import t from "../../../../../languages/pl";
import { buttonStyle } from "../buttonGroupStyle";
import withSubordinateUser from './../../../../HOC/withSubordinateUser';
import PrivateWorkingHoursRow from './PrivateWorkingHoursRow';

const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(3)
    },
    row: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(4)
    },
    timePicker: {
        marginLeft: theme.spacing(2)
    }
});

const PrivateWorkingsHours = props => {
    const { classes, name, onDialogOpen, startTime: start, endTime: end, isPrivateHoursMode, onSubmit, nonAdminUser } = props;
    const [open, setOpen] = useState(false);
    const [startTime, setStart] = useState(start);
    const [endTime, setEnd] = useState(end);
    const [privateWorkingHoursMode, setPrivateWorkingHoursMode] = useState(isPrivateHoursMode);

    useEffect(() => {
        setStart(start);
    }, [start]);

    useEffect(() => {
        setEnd(end);
    }, [end]);

    useEffect(() => {
        setPrivateWorkingHoursMode(isPrivateHoursMode);
    }, [isPrivateHoursMode]);

    const handleStartTimeChange = (time) => {
        setStart(moment(time).unix());
    };

    const handleEndTimeChange = (time) => {
        setEnd(moment(time).unix());
    };

    const handleIndividualTypeWorkChange = (isIndividualWorkType) => {
        setPrivateWorkingHoursMode(isIndividualWorkType);
    };

    const handleDialogOpen = () => {
        setOpen(true);
        if (onDialogOpen)
            onDialogOpen();
    };

    const handleSubmit = () => {
        if (onSubmit)
            onSubmit(privateWorkingHoursMode, startTime, endTime);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.individualWorkingHours}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="sm"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.individualWorkingHoursTitle} {name}
                </DialogTitle>
                <DialogContent>
                    <Table className={classes.content}>
                        <TableBody>
                            <PrivateWorkingHoursRow
                                displayName={t.individualWorkingHours}
                                individualWorkType={privateWorkingHoursMode}
                                isSwitch
                                onSwitchChange={handleIndividualTypeWorkChange}
                            />
                            <PrivateWorkingHoursRow
                                displayName={t.workStartTime}
                                time={startTime}
                                onTimeChange={handleStartTimeChange}
                                disabled={!privateWorkingHoursMode}
                            />
                            <PrivateWorkingHoursRow
                                displayName={t.workFinishTime}
                                time={endTime}
                                onTimeChange={handleEndTimeChange}
                                disabled={!privateWorkingHoursMode}
                            />
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <CancelAcceptForm
                        onCancel={() => setOpen(false)}
                        onSubmit={handleSubmit}
                        disableSubmit={nonAdminUser}
                    />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default compose(
    withStyles(useStyles),
    withSubordinateUser
)(PrivateWorkingsHours);

PrivateWorkingsHours.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    onDialogOpen: PropTypes.func,
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    isPrivateHoursMode: PropTypes.bool,
    onSubmit: PropTypes.func,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool
};
